module.exports = __webpack_public_path__ + "img/page_bg_investment.00c26790.png";